/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_OverlineInputs */

const en_fw_bm_overline = /** @type {(inputs: Fw_Bm_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUBLIC BENCHMARK`)
};

const id_fw_bm_overline = /** @type {(inputs: Fw_Bm_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BENCHMARK PUBLIK`)
};

/**
* | output |
* | --- |
* | "PUBLIC BENCHMARK" |
*
* @param {Fw_Bm_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_overline = /** @type {((inputs?: Fw_Bm_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_overline(inputs)
	return en_fw_bm_overline(inputs)
});